/**
 * Prayogams Master Index Structure for ahobilam.com-2025
 * Navigation Hierarchy: Vaidhikam -> Prayogams -> Division -> Topic
 */

export const PRAYOGAM_DIVISIONS = [
  {
    id: "samam-poorvam",
    title: "ஸாமம் - பூர்வம் (Samam - Poorvam)",
    subtitle: "ஸாம வேதம் பூர்வ காரியப் பிரயோகங்கள்",
    icon: "BookOpen",
    veda: "Samam",
    type: "Poorvam",
    topics: [
      { id: "mangala-dravya", title: "प्रातः प्रबोधानन्तरं मङ्गलद्रव्यावलोकनम्", titleTamil: "காலை விழிப்பு மற்றும் மங்கள திரவிய தரிசனம்", pageStart: 1 },
      { id: "shaucha-danta-snana", title: "शौचविधिः दन्तधावनं स्नानम्", titleTamil: "சௌச விதி, தந்ததாவனம் மற்றும் ஸ்நான விதி", pageStart: 12 },
      { id: "brahmayajna-tarpana", title: "ब्रह्मयज्ञः तर्पणकालः", titleTamil: "பிரம்மயக்ஞம் மற்றும் தர்பண காலம்", pageStart: 4 },
      { id: "yajnopavita-dharanam", title: "यज्ञोपवीतधारणम्", titleTamil: "யஞோபவீத தாரண விதி", pageStart: 7 },
      { id: "agnisandhanam-karika", title: "अग्निसन्धानम् कारिका", titleTamil: "அக்னி சந்தானம் மற்றும் காரிகைகள்", pageStart: 9 },
      { id: "opasanam-samajapa", title: "औपासनम् सामजपे विशेषः", titleTamil: "ஔபாஸனம் மற்றும் ஸாம ஜப விசேஷம்", pageStart: 17 },
      { id: "nandishraddha-punyahavachanam", title: "नान्दीश्राद्धविधिः पुण्याहवाचनम्", titleTamil: "நாந்தீசிரார்த்த விதி மற்றும் புண்யாஹவாசனம்", pageStart: 20 },
      { id: "udakashanti", title: "उदकशान्ति प्रयोगः", titleTamil: "உதகசாந்தி பிரயோகம்", pageStart: 26 },
      { id: "jatakarma-namakaranam", title: "जातकर्म नामकरणम्", titleTamil: "ஜாதகர்மம் மற்றும் நாமகரணம்", pageStart: 29 },
      { id: "annaprasanam-choulam", title: "अन्नप्राशन चौल प्रयोगौ", titleTamil: "அன்னப்ராசனம் மற்றும் சௌள பிரயோகம்", pageStart: 35 },
      { id: "upanayana-prayogah", title: "उपनयन प्रयोगः अष्टौ व्रतानि", titleTamil: "உபநயன பிரயோகம் மற்றும் 8 விரதங்கள்", pageStart: 37 },
      { id: "samavartanam", title: "समावर्तन प्रयोगः", titleTamil: "சமாவர்த்தன பிரயோகம்", pageStart: 55 },
      { id: "vivaha-prayogah", title: "उद्वाह प्रयोगः विवाहहोमः", titleTamil: "விவாஹப் பிரயோகம் (திருமணச் சடங்குகள்)", pageStart: 57 },
      { id: "ritu-shanti-seemantham", title: "पुंसवन सीमन्तोन्नयन प्रयोगौ", titleTamil: "பும்ஸவனம் மற்றும் சீமந்தோன்னயனம்", pageStart: 83 },
      { id: "vaishvadeva-prayogah", title: "वैश्वदेव प्रयोगः स्थालीपाकः", titleTamil: "வைஸ்வதேவ பிரயோகம் மற்றும் ஸ்தாலீபாகம்", pageStart: 87 }
    ]
  },
  {
    id: "samam-aparam",
    title: "ஸாமம் - அபரம் (Samam - Aparam)",
    subtitle: "ஸாம வேதம் அபர காரியப் பிரயோகங்கள்",
    icon: "Flame",
    veda: "Samam",
    type: "Aparam",
    topics: [
      { id: "apara-samskara-intro", title: "अपरप्रयोगः संस्कारनिर्णयः", titleTamil: "அபர பிரயோக அவதாரிகை மற்றும் சம்ஸ்கார நிர்ணயம்", pageStart: 229 },
      { id: "dahana-krama", title: "दहनकर्म विधिः", titleTamil: "தஹன கர்ம விதி", pageStart: 230 },
      { id: "sanchayana-krama", title: "अस्थिसञ्चयन विधिः", titleTamil: "அஸ்தி சஞ்சயன விதி", pageStart: 240 },
      { id: "ekadasaha-sapindikarana", title: "एकादशाहः सपिण्डीकरणम्", titleTamil: "ஏகாதசாஹம் மற்றும் சபிண்டீகரணம்", pageStart: 250 },
      { id: "apara-shraddha-prayogah", title: "श्राद्धप्रयोगः पिण्डप्रदानम्", titleTamil: "அபர சிரார்த்த பிரயோகம் மற்றும் பிண்ட பிரதானம்", pageStart: 260 },
      { id: "vrishti-varuna-prayoga", title: "वृष्टिप्रद वरुणजयप्रयोगः", titleTamil: "வருண ஜப பிரயோகம்", pageStart: 270 }
    ]
  },
  {
    id: "yajur-poorvam",
    title: "யஜுர் - பூர்வம் (Yajur - Poorvam)",
    subtitle: "ஆபஸ்தம்ப சூத்ரம் யஜுர் வேதம் பூர்வ காரியப் பிரயோகங்கள்",
    icon: "BookMarked",
    veda: "Yajur",
    type: "Poorvam",
    topics: [
      { id: "yajur-p-1", title: "उदकशान्ति प्रयोगः", titleTamil: "1. உதகசாந்தி பிரயோகம்", pageStart: 1 },
      { id: "yajur-p-2", title: "अङ्कुरार्पण प्रयोगः", titleTamil: "2. அங்குரார்ப்பணம் பிரயோகம்", pageStart: 20 },
      { id: "yajur-p-3", title: "प्रतिसरबन्ध कर्म प्रयोगः", titleTamil: "3. பிரதிசரபந்தம் (காப்புக்கட்டு)", pageStart: 34 },
      { id: "yajur-p-4", title: "हिरण्य (आम) रूप नान्दी श्राद्ध प्रयोगः", titleTamil: "4. நந்தி ஸ்ராத்தம் (நாந்தி)", pageStart: 59 },
      { id: "yajur-p-5", title: "सर्वतन्त्र साधारण अग्निमुख प्रयोगः", titleTamil: "5. அக்னிமுகம் பிரயோகம் (சாதாரண)", pageStart: 80 },
      { id: "yajur-p-6", title: "जातकर्म प्रयोगः", titleTamil: "6. ஜாதகர்மா பிரயோகம்", pageStart: 100 },
      { id: "yajur-p-7", title: "नामकरण प्रयोगः", titleTamil: "7. நாமகரணம் (பெயர் சூட்டுதல்)", pageStart: 120 },
      { id: "yajur-p-8", title: "अन्नप्राशन प्रयोगः", titleTamil: "8. அன்னப்ராசனம் (உணவு அளித்தல்)", pageStart: 140 },
      { id: "yajur-p-9", title: "चौळकर्म प्रयोगः", titleTamil: "9. சௌளகர்மா (முடி இறக்குதல்)", pageStart: 160 },
      { id: "yajur-p-10", title: "उपनयन प्रयोगः", titleTamil: "10. உபநயனம் (பூணூல் அணிவித்தல்)", pageStart: 180 },
      { id: "yajur-p-11", title: "पालाश कर्म प्रयोगः", titleTamil: "11. பாலாஸ கர்மா பிரயோகம்", pageStart: 200 },
      { id: "yajur-p-12", title: "प्राजापत्यादि व्रत उपक्रम प्रयोगः", titleTamil: "12. பிராஜாபத்யாதி விரத உபாகர்மா", pageStart: 220 },
      { id: "yajur-p-13", title: "समानतन्त्र उत्सर्जन प्रयोगः", titleTamil: "13. விரத உத்சர்ஜனம் பிரயோகம்", pageStart: 240 },
      { id: "yajur-p-14", title: "विवाह प्रयोगः", titleTamil: "14. விவாஹம் பிரயோகம் (திருமணம்)", pageStart: 260 },
      { id: "yajur-p-15", title: "औपासन प्रयोगः", titleTamil: "15. ஔபாஸனம் பிரயோகம்", pageStart: 280 },
      { id: "yajur-p-16", title: "गृहप्रवेश प्रयोगः", titleTamil: "16. கிருஹப்பிரவேசம் பிரயோகம்", pageStart: 300 },
      { id: "yajur-p-17", title: "दर्शपूर्णमासस्थालीपाक प्रयोगः", titleTamil: "17. தர்சபூர்ணமாஸ ஸ்தாலீபாகம்", pageStart: 320 }
    ]
  },
  {
    id: "yajur-aparam",
    title: "யஜுர் - அபரம் (Yajur - Aparam)",
    subtitle: "யஜுர் வேதம் அபர காரியப் பிரயோகங்கள்",
    icon: "ShieldAlert",
    veda: "Yajur",
    type: "Aparam",
    topics: [
      { id: "yajur-apara-coming-soon", title: "यजुर्वेद अपरप्रयोगः (शीघ्रमेव)", titleTamil: "யஜுர் வேத அபரப் பிரயோகங்கள் (விரைவில் சேர்க்கப்படும்)", pageStart: 1 }
    ]
  }
];
